import request from '@wearetla/tla-essentials-tools/utilities/request';

// Functions
import formatDate from '@wearetla/tla-essentials-tools/functions/format-date';

const parseOrderProducts = (rawProducts) => {
	return rawProducts.reduce((products, product) => {
		const arrayProduct = products.find(
			(loopProduct) => loopProduct.menu_product?.id === product.menu_product?.id
		) ?? {
			...product,
			price: 0,
			ids: [],
			quantity: 0,
		};

		return [
			...products.filter(
				(loopProduct) => loopProduct.menu_product?.id !== product.menu_product?.id
			),
			{
				...arrayProduct,
				ids: [...arrayProduct.ids, product.id],
				price: arrayProduct.price + product.price,
				quantity: arrayProduct.quantity + 1,
			},
		];
	}, []);
};

const orderServices = {
	getActiveOrders: () => {
		return new Promise((resolve, reject) => {
			orderServices
				.getUserOrders('active')
				.then((payload) => {
					resolve(payload?.orders);
				})
				.catch(reject);
		});
	},
	prepare: (products, branchSlug, tableNumber) => {
		return new Promise((resolve, reject) => {
			request.post(
				'order/prepare-product',
				{
					type: 'PRODUCT',
					products,
					branch_slug: branchSlug,
					table_number: tableNumber,
				},
				function (payload, status, request) {
					if (payload?.order) {
						resolve({
							...payload.order,
						});
					} else {
						reject(
							request?.data?.meta?.messages || 'Sipariş oluşturulurken bir hata ile karşılaşıldı.'
						);
					}
				}
			);
		});
	},
	getOrder: (orderId) => {
		return new Promise((resolve, reject) => {
			request.get(`order/detail/${orderId}`, false, function (payload, status, request) {
				if (payload?.order) {
					resolve({
						...payload.order,
						delivery_types: (payload.delivery_types ?? []).map((type) => ({
							...type,
							value: type.id.toString(),
							label: type.label,
						})),
						delivery_type: (() => {
							const deliveryType = (payload.order.extras ?? []).find(
								(extra) => extra.relation_name === 'DELIVERY_SERVICE'
							);

							return deliveryType
								? {
										...deliveryType,
										id: deliveryType.relation_id?.toString?.(),
									}
								: null;
						})(),
						products: parseOrderProducts(payload.order.products),
						// DUMMY
						delivery_price: {
							currency_prefix: null,
							currency_suffix: 'TL',
							old_price: null,
							old_price_formatted: null,
							price: 20,
							price_formatted: (20).toString().replace('.', ','),
						},
						total_price: {
							currency_prefix: null,
							currency_suffix: 'TL',
							old_price: null,
							old_price_formatted: null,
							price: payload.order.total_price,
							price_formatted: payload.order.total_price.toString().replace('.', ','),
						},
					});
				} else {
					reject(
						request?.data?.meta?.messages || 'Sipariş getirilirken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	updateOrderDelivery: (orderId, deliveryType) => {
		return new Promise((resolve, reject) => {
			request.put(
				`order/${orderId}/delivery/${deliveryType}`,
				false,
				function (payload, status, request) {
					if (status === 200) {
						resolve(payload);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Teslimat yöntemi güncellenirken bir hata ile karşılaşıldı.'
						);
					}
				}
			);
		});
	},
	getUserOrders: (mode = 'all', filters) => {
		return new Promise((resolve, reject) => {
			request.get(`user/orders/product/${mode}`, filters, (payload, status, request) => {
				if (status === 200 && payload.orders) {
					resolve({
						orders: payload.orders.map((order) => ({
							...order,
							created_at_formatted: formatDate(order.created_at, 'd.MM.yyyy HH:mm'),
							created_at_formatted_date: formatDate(order.created_at, 'd.MM.yyyy'),
							created_at_formatted_time: formatDate(order.created_at, 'HH:mm'),
							products: parseOrderProducts(order.products),
						})),
						pagination: request.data.pagination,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Siparişler getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.'
					);
				}
			});
		});
	},
};

export default orderServices;
